import { useEffect, useMemo, useState } from "react";
import AstrologerSlider from "../Sliders/AstrologerSlider";
import {
  fetchAstrologers,
  filterAstrologersByTab,
} from "../../api/astrologerApi";

export default function OccultClinic() {
  const [astrologers, setAstrologers] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchAstrologers()
      .then(({ astrologers: items, tabs: apiTabs }) => {
        if (cancelled) return;
        setAstrologers(items);
        setTabs(apiTabs);
        setActiveCategory((current) =>
          apiTabs.includes(current) ? current : apiTabs[0] || ""
        );
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || "Failed to load live astrologers");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const filtered = useMemo(
    () => filterAstrologersByTab(astrologers, activeCategory),
    [astrologers, activeCategory]
  );

  return (
    <section className="space-top">
      <div className="container">
        <h2 className="text-lora font-semibold">Online Occult Clinic</h2>
        <p>
          Step into a live cosmic session—speak directly with our experts and
          uncover clarity, fortune, and balance.
        </p>

        {tabs.length > 0 && (
          <div className="astro-filter-tabs d-flex flex-nowrap gap-2 mb-4">
            {tabs.map((category) => (
              <button
                key={category}
                type="button"
                className={`btn cutom-tab-style astro-filter-tab ${
                  activeCategory === category ? "active-tab-btn-style" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}

        {loading && <p className="text-center py-4">Loading clinic...</p>}
        {error && <p className="text-center text-danger py-4">{error}</p>}
        {!loading && !error && filtered.length === 0 && (
          <p className="text-center py-4">
            {activeCategory
              ? `No live astrologers available for ${activeCategory}.`
              : "No live astrologers available."}
          </p>
        )}
        {filtered.length > 0 && (
          <AstrologerSlider
            astrologers={filtered}
            actionLabel="Book a Consultation"
            actionTo="/consult"
            online
            activeCategory={activeCategory}
          />
        )}
      </div>
    </section>
  );
}
